module.exports = __webpack_public_path__ + "img/thomas-cary.1cf62c38.png";